module.exports = __webpack_public_path__ + "static/media/oval.94b9e20b.png";